// extracted by mini-css-extract-plugin
export default {"closeBtn":"styles_closeBtn__ZYAnb"};